// extracted by mini-css-extract-plugin
export default {"root":"AppShell-module__root___zHWec","appShell":"AppShell-module__appShell___TczwL"};